module.exports = __webpack_public_path__ + "media/images/icons/icon-copy-c5c45319ef5271924b528add949abee6.svg";